import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom';
import qs from 'qs';
import buscarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/buscarFechamentoCaixa';
import { arredondamentoPadrao, formatarReal, realParaNumber } from '../../../util/numberUtil';

export class PainelDetalhamentoFechamentoCaixa extends React.Component {
  constructor (props) {
    super(props);
    this.componentRef = React.createRef();
  }

  imprimir () {
    window.print();
  }

  componentDidMount () {
    if (this.props.empresaSelecionada.id) {
      const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
      if (parametros.usuarioEmpresa && parametros.data) {
        this.props.buscarFechamentoCaixa(this.props.empresaSelecionada.id, parametros.usuarioEmpresa, parametros.data, parametros.fechamento);
      }
    } else {
      this.props.history.push('/painel-fechamento-caixa')
    }
  }

  exbirLinhaTotal (titulo, valor) {
    return <tr>
      <td>
        {titulo}
      </td>
      <td>
        {arredondamentoPadrao(realParaNumber(valor))
          .toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL'
          })}
      </td>
    </tr>
  }

  exibirHistoricos () {
    if (this.props.fechamentoCaixa.historicos && this.props.fechamentoCaixa.historicos.length) {
      return <table className="table table-sm table-striped table-bordered text-center page-break">
        <thead>
        <tr>
          <td colSpan={8}>
            <strong>Movimentações do caixa</strong>
          </td>
        </tr>
        <tr>
          <th scope="col">Data e Hora</th>
          <th scope="col">Situação</th>
          <th scope='col'>Usuário</th>
          <th scope="col">Observação</th>
        </tr>
        </thead>
        <tbody>
        {this.props.fechamentoCaixa.historicos.map(historico =>
          <tr key={`historico-${historico.dataHora}`}>
            <td>
              <span>{historico.dataHora}</span>
            </td>
            <td>
              <span>{historico.descricaoSituacao}</span>
            </td>
            <td>
              <span>{historico.nomeUsuario}</span>
            </td>
            <td>
              <span>{historico.observacao}</span>
            </td>
          </tr>)}
        </tbody>
      </table>
    }
  }

  calcularTotalValorEncomenda (encomendas) {
    let valor = 0;
    encomendas.forEach(encomenda => {
      encomenda.encomendas.forEach(encomenda2 => {
        if (encomenda.situacao === 'Cancelado') {
          valor = valor - realParaNumber(encomenda2.valor)
        } else {
          valor = valor + realParaNumber(encomenda2.valor)
        }
      })
    })

    return formatarReal(valor.toString())
  }

  calcularTotalValorReservas (reservas) {
    let valor = 0;
    reservas.forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva.situacao === 'Cancelado') {
          valor = valor - realParaNumber(reserva2.valorTotalReserva)
        } else {
          if (reserva2.seRemarcacao) {
            valor = valor + realParaNumber(reserva2.custoRemarcacao)
          } else {
            valor = valor + realParaNumber(reserva2.valorTotalReserva)
          }
        }
      })
    })

    return formatarReal(valor.toString())
  }

  exibirEncomendas () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const encomendas = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'ENCOMENDA');
      if (encomendas.length) {
        return <table className="table table-sm table-striped table-bordered text-center page-break">
          <thead>
          <tr>
            <td colSpan={8}>
              <strong>Encomendas</strong>
            </td>
          </tr>
          <tr>
            <th scope="col">Pedido</th>
            <th scope="col">Remetente</th>
            <th scope='col'>Situação</th>
            <th scope="col">Pagamento</th>
            <th scope="col">VL Imposto</th>
            <th scope="col">VL Comissão</th>
            <th scope="col">VL Pedágio</th>
            <th scope="col">Valor</th>
          </tr>
          </thead>
          <tbody>
          {encomendas.map(encomenda =>
            encomenda.encomendas.map(encomenda2 =>
              <tr key={`reserva-${encomenda2.id}`}>
                <td>
                  <span>{encomenda2.idPedido}</span>
                </td>
                <td>
                  <span>{encomenda2.remetente.nome}</span>
                </td>
                <td>
                  <span>{encomenda.situacao}</span>
                </td>
                <td>
                  <span>{encomenda2.descricaoFormasPagamento}</span>
                </td>
                <td>
                  {encomenda.situacao === 'Cancelado' ? ' - ' : ''}
                    <span>{formatarReal(encomenda2.impostoRetido)}</span>
                </td>
                <td>
                  {encomenda.situacao === 'Cancelado' ? ' - ' : ''}
                    <span>{formatarReal(encomenda2.comissao)}</span>
                </td>
                <td>
                  {encomenda.situacao === 'Cancelado' ? ' - ' : ''}
                      <span>{formatarReal(encomenda2.pedagio)}</span>
                </td>
                <td>
                  {encomenda.situacao === 'Cancelado' ? ' - ' : ''}
                  <span>{formatarReal(encomenda2.valor)}</span>
                </td>
              </tr>))}
          </tbody>
          <tfoot>
          <tr>
            <td colSpan={4}><strong>TOTAL EM ENCOMENDAS</strong></td>
            <td><span>{formatarReal(this.props.fechamentoCaixa.totais.totalImpostoRetidoEncomendas)}</span></td>
            <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoEncomendas)}</td>
            <td>{formatarReal(this.props.fechamentoCaixa.totais.totalPedagio)}</td>
            <td>{this.calcularTotalValorEncomenda(encomendas)
              .toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })}</td>
          </tr>
          </tfoot>
        </table>
      }
    }
  }

  exibirBagagens () {
      if (this.props.fechamentoCaixa.detalhamento) {
        const detalhamentos = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'BAGAGEM');
        if (detalhamentos.length) {
          return <table className="table table-sm table-striped table-bordered text-center page-break">
            <thead>
            <tr>
              <td colSpan={8}>
                <strong>Bagagens</strong>
              </td>
            </tr>
            <tr>
              <th scope="col">Reserva</th>
              <th scope="col">Passageiro</th>
              <th scope='col'>Situação</th>
              <th scope="col">Rastreio</th>
              <th scope="col">VL Imposto</th>
              <th scope="col">VL Comissão</th>
              <th scope="col">Peso KG</th>
              <th scope="col">Valor</th>
            </tr>
            </thead>
            <tbody>
            {detalhamentos.map(detalhamento =>
              detalhamento.bagagens.map(bagagem =>
                <tr key={`reserva-${bagagem.id}`}>
                  <td>
                    <span>{bagagem.reservaId}</span>
                  </td>
                  <td>
                    <span>{bagagem.nomePassageiro}</span>
                  </td>
                  <td>
                    <span>{detalhamento.situacao}</span>
                  </td>
                  <td>
                    <span>{bagagem.codigoRastreio}</span>
                  </td>
                  <td>
                    {detalhamento.situacao === 'Cancelado' ? ' - ' : ''}
                      <span>{'R$ ' + bagagem.impostoRetido.toLocaleString('pt-BR', {minimumFractionDigits: 2,
                                                                               maximumFractionDigits: 2})}</span>
                  </td>
                  <td>
                    {detalhamento.situacao === 'Cancelado' ? ' - ' : ''}
                      <span>{'R$ ' + bagagem.comissao.toLocaleString('pt-BR', {minimumFractionDigits: 2,
                                                                                                     maximumFractionDigits: 2})}</span>
                  </td>
                <td>
                  {detalhamento.situacao === 'Cancelado' ? ' - ' : ''}
                  <span>{'kg ' + bagagem.peso.toLocaleString('pt-BR', {minimumFractionDigits: 2,
                                                       maximumFractionDigits: 2
                                                     })}</span>
                </td>
                  <td>
                    {detalhamento.situacao === 'Cancelado' ? ' - ' : ''}
                    <span>{'R$ ' + bagagem.valor.toLocaleString('pt-BR', {minimumFractionDigits: 2,
                                                         maximumFractionDigits: 2})}</span>
                  </td>
                </tr>))}
            </tbody>
            <tfoot>
            <tr>
              <td colSpan={4}><strong>TOTAL EM BAGAGENS</strong></td>
              <td><span>{formatarReal(this.props.fechamentoCaixa.totais.totalImpostoRetidoBagagens)}</span></td>
              <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoBagagens)}</td>
              <td>-</td>
              <td>{this.props.fechamentoCaixa.totais.totalEmBagagensAprovadas
                .toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                })}</td>
            </tr>
            </tfoot>
          </table>
        }
      }
    }

  exibirValorNegativoComissao (valor) {
    return valor > 0 ? <span>-{formatarReal(valor)}</span> : <span>R$0.00</span>
  }

  exibirValorNegativoImposto (valor) {
    return valor > 0 ? <span>-{formatarReal(valor)}</span> : <span>R$0.00</span>
  }

  exibirValorImpostoRetidoAprovadas (reservas, reservaCorrente) {
    let valor = formatarReal(reservaCorrente.impostoRetido);
    reservas.filter(f=> f.situacao === 'Cancelado').forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva2.id === reservaCorrente.id &&
          reservaCorrente.idRemarcada !== null &&
          reservaCorrente.custoRemarcacao === null
        ) {
          valor = 'R$0,00'
          return
        }
      })
    })
    return valor
  }


  exbibirReservas (situacoes, titulo, exibirRodape) {
    if (this.props.fechamentoCaixa.detalhamento) {
      const reservas = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'PASSAGEM' && situacoes.includes(f.situacao));
      if (reservas.length) {
        return <table className="table table-sm table-striped table-bordered text-center page-break">
          <thead>
          <tr>
            <td colSpan={12}>
              <strong>{titulo}</strong>
            </td>
          </tr>
          <tr>
            <th scope="col">Pedido</th>
            <th scope="col">Passageiro</th>
            <th scope='col'>Situação</th>
            <th scope="col">Poltrona</th>
            <th scope="col">Pagamento</th>
            <th scope="col">Imposto</th>
            <th scope="col">Comissão</th>
            <th scope="col">Pedágio</th>
            <th scope="col">Embarque</th>
            <th scope="col">Seguro</th>
            {situacoes.includes('Cancelado') ? <th scope="col">Valor de estorno</th> : null}
            <th scope="col">Valor</th>
          </tr>
          </thead>
          <tbody>
          {reservas.map(reserva =>
            reserva.reservas.map(reserva2 =>
              <tr key={`reserva-${reserva2.id}`}>
                <td>
                  <span>{reserva2.pedidoId}</span>
                </td>
                <td>
                  <span>{reserva2.passageiroDto.nome}</span>
                </td>
                <td>
                  <span>{reserva.situacao}</span>
                </td>
                <td>
                  <span>{reserva2.numeroPoltrona}</span>
                </td>
                <td>
                  <span>{reserva2.descricaoFormasPagamento}</span>
                </td>
                <td>
                  {reserva.situacao === 'Cancelado' ?
                    this.exibirValorNegativoImposto(reserva2.estornoImpostoRetido) :
                    <span>{this.exibirValorImpostoRetidoAprovadas(reservas, reserva2)}</span>
                  }
                </td>
                <td>
                  {reserva.situacao === 'Cancelado' ?
                    this.exibirValorNegativoComissao(reserva2.estornoComissao) :
                    <span>{formatarReal(reserva2.comissao)}</span>
                  }
                </td>
                <td>
                  {reserva.situacao === 'Cancelado' ?
                      this.exibirValorNegativoComissao(reserva2.pedagio) :
                      <span>{formatarReal(reserva2.pedagio)}</span>
                  }
                </td>
                <td>
                  {reserva.situacao === 'Cancelado' ?
                    this.exibirValorNegativoComissao(reserva2.taxaEmbarque) :
                    <span>{reserva2.taxaEmbarque}</span>
                  }
                </td>
                <td>
                  {reserva2.temEstornoSeguro ?
                      this.exibirValorNegativoComissao(reserva2.tarifaSeguro) :
                      <span>{reserva2.tarifaSeguro}</span>
                  }
                </td>
                {situacoes.includes('Cancelado') ?
                  <td>
                    <span>{reserva.situacao === 'Cancelado' ? formatarReal(reserva2.valorEstorno) : '-'}</span>
                  </td> : null}
                <td>
                  {reserva2.seRemarcacao && reserva.situacao !== 'Cancelado' ?
                    <span>{this.exibirSinalSubtracao(reserva.situacao, reserva2.custoRemarcacao)}{formatarReal(reserva2.custoRemarcacao)}</span> :
                    <span>{this.exibirSinalSubtracao(reserva.situacao, reserva2.valor)}{formatarReal(reserva2.valor)}</span>}
                </td>

              </tr>))}
          </tbody>
          {exibirRodape ?
            <tfoot>
            <tr>
              <td colSpan={situacoes.includes('Cancelado') ? 5 : 4}><strong>TOTAL EM RESERVAS</strong></td>
              <td><span>{formatarReal(this.props.fechamentoCaixa.totais.totalImpostoRetidoReservas)}</span></td>
              <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoReservas)}</td>
              <td>{formatarReal(this.props.fechamentoCaixa.totais.totalPedagio)}</td>
              <td></td>
              <td>{formatarReal(this.props.fechamentoCaixa.totais.totalTarifaSeguro)}</td>
              <td></td>
              <td>{formatarReal(this.props.fechamentoCaixa.totais.totalEmReservas)}</td>
            </tr>
            </tfoot> : null}
        </table>
      }
    }
  }

  exbibirEstornos (titulo) {
    if (this.props.fechamentoCaixa.detalhamento) {
      const detalhamentos = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'PASSAGEM' && 'Seguro Cancelado'.includes(f.situacao));
      if (detalhamentos && detalhamentos.length) {
        return <table className="table table-sm table-striped table-bordered text-center page-break">
          <thead>
          <tr>
            <td colSpan={12}>
              <strong>{titulo}</strong>
            </td>
          </tr>
          <tr>
            <th scope="col">Pedido</th>
            <th scope="col">Reserva</th>
            <th scope="col">Passageiro</th>
            <th scope='col'>Situação</th>
            <th scope="col">Poltrona</th>
            <th scope="col">Valor</th>
          </tr>
          </thead>
          <tbody>
          {detalhamentos.map(detalhamento =>
          detalhamento.estornos ?
              detalhamento.estornos.map(estorno =>
                  <tr key={`reserva-${estorno.id}`}>
                    <td>
                      <span>{estorno.idPedido}</span>
                    </td>
                    <td> <span>{estorno.idReserva}</span></td>
                    <td>
                      <span>{estorno.nomePassageiro}</span>
                    </td>
                    <td>
                      <span>Cancelado</span>
                    </td>
                    <td>
                      <span>{estorno.poltrona}</span>
                    </td>
                    <td>{this.exibirValorNegativoComissao(estorno.valor)}</td>

                  </tr>):'')}
          </tbody>
              <tfoot>
              <tr>
                <td colSpan='4'><strong>TOTAL EM RESERVAS</strong></td>
                <td><span></span></td>
                <td>-R${this.props.fechamentoCaixa.totais.totalCancelamentoSeguro}</td>
              </tr>
              </tfoot>
        </table>
      }
    }
  }

  exibirSinalSubtracao (situacao, valor) {
    if (situacao === 'Cancelado' && realParaNumber(valor) > 0) {
      return ' -';
    }
  }

  exibir () {
    return <React.Fragment>
      <div className='mt-2'>
        <div className="invoice-title">
          <div className="row justify-content-around">
            <div className="col-md-4">
              <strong>{this.props.empresaSelecionada.nome}</strong>
            </div>
            <div className="col-md-6">
              <strong>Vendedor: {this.props.fechamentoCaixa.nomeUsuario}</strong>
            </div>
            <div className="col-md-2">
              <strong>Data: {this.props.fechamentoCaixa.dataFechamento}</strong>
            </div>
          </div>
          <hr/>
        </div>
        <div className="row">
          <div className="col-md-6">
            <table className="table table-sm table-bordered">
              <tbody>
              {this.exbirLinhaTotal('(+) Total Tx de Serviço', this.props.fechamentoCaixa.totais.totalTaxaServico)}
              {this.exbirLinhaTotal('(+) Total Tx de Pedágio', this.props.fechamentoCaixa.totais.totalPedagio)}
              {this.exbirLinhaTotal('(+) Total adiantamento baixado', this.props.fechamentoCaixa.totais.totalAdiantamentoBaixado)}
              {this.exbirLinhaTotal('(-) Total adiantamento lançado', this.props.fechamentoCaixa.totais.totalAdiantamentoLancado)}
              {this.exbirLinhaTotal('(-) Total despesas', this.props.fechamentoCaixa.totais.totalDespesas)}
              {this.exbirLinhaTotal('(-) Total Lançamentos a receber', this.props.fechamentoCaixa.totais.totalLancamentoAReceber)}
              {this.exbirLinhaTotal('(-) Total de Seguro', this.props.fechamentoCaixa.totais.totalTarifaSeguro)}
              {this.exbirLinhaTotal('(-) Total imposto retido', this.props.fechamentoCaixa.totais.totalImpostoRetido)}
              {this.exbirLinhaTotal('(-) Total seguro e imposto retido', this.props.fechamentoCaixa.totais.totalTarifaSeguroImpostoRetido)}
              {this.exbirLinhaTotal('(+) Total de vendas', this.props.fechamentoCaixa.totais.totalVendas)}
              </tbody>
            </table>
          </div>
          <div className="col-md-6">
            <table className="table table-sm table-bordered">
              <tbody>
              {this.exbirLinhaTotal('(-) Total recebido cartão', this.props.fechamentoCaixa.totais.totalRecebidoCartao)}
              {this.exbirLinhaTotal('(-) Total recebido PIX', this.props.fechamentoCaixa.totais.totalRecebidoPix)}
              {this.exbirLinhaTotal('(-) Total de cancelamentos', this.props.fechamentoCaixa.totais.totalCancelamento)}
              {this.exbirLinhaTotal('(+) Total recebido cartão no site', this.props.fechamentoCaixa.totais.totalRecebidoCartaoSite)}
              {this.exbirLinhaTotal('(+) Total de residual de cancelamentos', this.props.fechamentoCaixa.totais.totalCustoCancelamento)}
              {this.exbirLinhaTotal('(+) Total excesso bagagem', this.props.fechamentoCaixa.totais.totalExcessoBagagem)}
              {this.exbirLinhaTotal('(-) Total comissão Reimpressão', this.props.fechamentoCaixa.totais.totalReimpressaoRecibo)}
               {this.exbirLinhaTotal('(-) Total comissão', this.props.fechamentoCaixa.totais.totalComissao)}
              {this.exbirLinhaTotal('( Informativo ) Total desconto', this.props.fechamentoCaixa.totais.totalDesconto)}
              {this.exbirLinhaTotal('(=) Total Tx de Embaque CEA', this.props.fechamentoCaixa.totais.totalTaxaEmbarqueCEA)}
              {this.exbirLinhaTotal('(=) Total do deposito', this.props.fechamentoCaixa.totais.totalDeposito)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.exbibirReservas(['Em aberto', 'Remarcada'], 'Reservas Abertas/Remarcadas')}
          </div>
        </div>
        <div>
          <div className="col-md-12">
            {this.exbibirEstornos('Seguros Cancelados')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.exbibirReservas(['Cancelado', 'Aprovado'], 'Reservas Canceladas/Aprovadas', true)}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.exibirEncomendas()}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.exibirBagagens()}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.exibirHistoricos()}
          </div>
        </div>
        <div className='row text-center mt-5'>
          <div className="col-md-12">
            <p style={{ textDecoration: 'overline' }}>Assinatura do Responsável (Por Extenso)</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  }

  exibirBotoes () {
    return (
      <React.Fragment>
        <div className='row justify-content-md-center mt-2' id='printPageButton'>
          <Link className="ml-2" to="/painel-fechamento-caixa">
            <button className='btn btn-sm btn-laranja'>Concluir</button>
          </Link>
          <a target="_BLANK" onClick={() => this.imprimir()} style={{ cursor: 'pointer' }} className="btn  btn-sm btn-laranja ml-2">
            <i className="material-icons mr-1" style={{
              fontSize: '18px',
              verticalAlign: 'middle'
            }}>
              &#xe8ad;
            </i>
            Imprimir
          </a>
        </div>
      </React.Fragment>)
  }

  render () {
    if (this.props.fechamentoCaixa) {
      return <React.Fragment>
        <div className="grid invoice">
          {this.exibirBotoes()}
          <div ref={this.componentRef} className="grid-body" id='cupom-encomenda' style={{
            fontSize: 16,
            fontWeight: 'bold'
          }}>
            <div className='text-center mb-4'>
              <h1>Fechamento de caixa</h1>
            </div>
            {this.exibir()}
          </div>
          {this.exibirBotoes()}
        </div>
      </React.Fragment>
    }
    return '';
  }
}


export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada,
    fechamentoCaixa: state.fechamentoCaixa
  });


export default withRouter(connect(mapStateToProps, { buscarFechamentoCaixa })(PainelDetalhamentoFechamentoCaixa));
